import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "license-title" }
const _hoisted_2 = { class: "flex justify-center" }
const _hoisted_3 = { class: "app-license" }


export default {
  __name: 'LicenseFooter',
  props: ['color'],
  setup(__props) {



return (_ctx, _cache) => {
  const _component_van_image = _resolveComponent("van-image")

  return (_openBlock(), _createElementBlock("div", {
    class: "license-footer",
    style: _normalizeStyle({ color: __props.color })
  }, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('license.title')), 1),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_image, {
        class: "logo-pagcor",
        src: require('@/assets/img/common/logo-pagcor.png')
      }, null, 8, ["src"])
    ]),
    _createElementVNode("div", _hoisted_3, "@" + _toDisplayString(_ctx.$t('license.content')), 1)
  ], 4))
}
}

}